import { create } from 'zustand';

interface RedoModalStore {
  isOpen: boolean;
  confirmRedo: boolean;
  onOpen: () => void;
  onClose: () => void;
  onConfirmRedoOpen: () => void;
  onConfirmRedoClose: () => void;
}

const useRedoModal = create<RedoModalStore>(set => ({
  isOpen: false,
  confirmRedo: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
  onConfirmRedoOpen: () => set({ confirmRedo: true }),
  onConfirmRedoClose: () => set({ confirmRedo: false }),
}));

export default useRedoModal;
